"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/typography/style");
var _typography = _interopRequireDefault(require("antd/lib/typography"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Text = _typography.default.Text;
function CardMask(_ref) {
  var last4 = _ref.last4;
  return /*#__PURE__*/_react.default.createElement(Text, null, "**** **** **** ", last4);
}
var _default = CardMask;
exports.default = _default;